import React, { useState } from 'react'
import Button from '~/Common-Objects/UI/Forms/Button/Button';
import Icons from '~/Common-Objects/UI/Icons/index';

export default function DeleteTag({ tag, onConfirm = () => { }, onCancel = () => { } }) {
    const [error, setError] = useState('')
    const confirm = async () => {
        try {
            await onConfirm()
        } catch (e) {
            setError(e.data.error)
        }
    }


    return (
        <div>
            <h4 className="mar-b25">Delete Tag</h4>
            <div className="mar-b25">Are you sure you want to delete {tag.tagName}?</div>

            <div className="row">
                <div className="col-xs-6">
                    <Button text="Delete" className="button-red button-fullwidth" onClick={confirm} iconLeft={<Icons icon="cross" />} />
                </div>
                <div className="col-xs-6">
                    <Button text="Cancel" className="button-fullwidth" onClick={onCancel} />
                </div>

                {!!error && <div className='col-xs-12 mar-t10 text-red'>
                    {error}
                </div>}
            </div>

        </div>
    )
}